module.exports = __webpack_public_path__ + "img/facilityInfo_3_6.024bcb3f.jpg";